<template>
  <error-pages-form
    :errorpage-id="errorpageId"
    :distribution-id="distributionId"
    details
    @submit="editErrorPage"
    @close="onClose"
  />
</template>
<script>
import ErrorPagesForm from './ErrorPagesForm.vue'

export default {
  name: 'EditErrorPage',
  components: {
    ErrorPagesForm,
  },
  data() {
    return {
      distributionId: null,
      errorpageId: null,
    }
  },
  created() {
    this.distributionId = this.$route.params.id
    this.errorpageId = Number(this.$route.params.errorpageId)
  },
  methods: {
    editErrorPage(errorPage) {
      this.$store.dispatch('cdn/updateErrorPage', errorPage).then(() => {
        this.successToast('Error page was updated')
        this.onClose()
      })
    },

    onClose() {
      this.$router.push({ name: 'distribution-error-pages', params: { id: this.distributionId } })
    },
  },
}
</script>
